import { render, staticRenderFns } from "./DashBoardTable.vue?vue&type=template&id=7a479b77&scoped=true"
import script from "./DashBoardTable.vue?vue&type=script&lang=js"
export * from "./DashBoardTable.vue?vue&type=script&lang=js"
import style0 from "./DashBoardTable.vue?vue&type=style&index=0&id=7a479b77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a479b77",
  null
  
)

export default component.exports